module.exports = __webpack_public_path__ + "static/home-a756211be552bdd1dd517cc8bc7b61ca.jpg";